<template>
    <div v-if="data">
        <van-nav-bar
            title="支付"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
        />
        <div class="bg-light margin-top">
            <van-cell-group>
                <van-cell title="购买内容" :value="data.title" title-style="flex:unset !important;width:100px;"/>
                <van-cell title="商品类型" :value="data.order_type === 'bids' ? '标讯' : 'VIP'" />
                <van-cell title="金额" :value="'￥'+data.pay_amount" />
            </van-cell-group>
        </div>
        <div class="margin-top">
            <van-button block square type="info" @click="toPay">立即支付</van-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "pay",
    data(){
        return{
            data:null,
            openid:''
        }
    },
    created() {
      let _this = this;
      this.data = this.$route.query;
      // this.data.openid = '';
      this.data.pay_type = 'weixin';

      if(!this.data.uid) {
        this.data.uid = this.$user.getUid();
      }

      // if(!this.data.uid){
      //   this.$dialog.confirm({
      //     title: '提示',
      //     message: '登录后才可继续支付',
      //     confirmButtonText:'立即登录',
      //     cancelButtonText:'返回首页'
      //   })
      //     .then(() => {
      //       this.$store.commit('lastPath',_this.$route.fullPath);
      //       _this.$router.replace({path:'/login'})
      //     })
      //     .catch(() => {
      //       _this.$router.replace({path:'/'})
      //     });
      // }
    },
    mounted() {
      if (this.data){
        this.getOpenId();
      }

      console.log(this.data);
    },
    methods:{
        toPay(){
            let _this = this;

            this.$http.post({
                url:'Common/addOrder',
                data:this.data,
                success(res){
                    console.log(res);
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', _this.onBridgeReady, false);
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', _this.onBridgeReady);
                            document.attachEvent('onWeixinJSBridgeReady', _this.onBridgeReady);
                        }
                    } else {
                        _this.onBridgeReady(res);
                    }
                    // _this.info = res;
                    //this.$store.commit('reAddress',_d);
                }
            })
        },
        onBridgeReady(data){
            var _this = this;
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest', data,
                function(res){
                    if(res.err_msg === "get_brand_wcpay_request:ok" ){
                        _this.$toast({
                            message: '支付成功',
                            position: 'top',
                        });
                        let _url = _this.$route.query.url ? _this.$route.query.url : '';
                        _this.$router.replace({path:'/order/paydone',query:{url:_url}});
                        // window.location.href = '/system/newcrowd/paydone?id='+_this.queryData.id;
                        // _this.$router.replace({path:'/paydone/',query:{id:this.queryData.id}})
                    }else{
                        _this.$toast({
                            message: '支付失败',
                            position: 'top',
                        });
                    }
                });
        },
        getOpenId(){
            let _this = this;
            if (!this.data.openid) {
                if (!this.$route.query.code) {
                    let _url = window.location.href;
                    let _wxUrl = this.$utils.getFWWxCodeUrl(_url);
                    window.location.replace(_wxUrl);
                } else {
                    this.$http.post({
                        url: 'Common/getFwOpenid',
                        data: {code: this.$route.query.code},
                        success: function (res) {
                            if(res.openid) {
                                _this.$user.setFuwuOpenid(res.openid);
                                _this.data.openid = res.openid;
                            }
                        }
                    });
                }
            }
        }
    }
}
</script>
